import data1 from '@com.amway.commerce/abomonetization-myshopconfig-v1-prod/data.json'; 
import data2 from '@com.amway.commerce/abomonetization-myshopconfig-v1-prod/data-tha.json'; 
import data3 from '@com.amway.commerce/abomonetization-myshopconfig-v1-prod/data-latam.json'; 
import data4 from '@com.amway.commerce/cart-cartconfig-v1-prod/data.json'; 
import data5 from '@com.amway.commerce/checkout-config-v1-prod/data.json'; 
import data6 from '@com.amway.commerce/identity-identity-config-v1-prod/data.json'; 
import data7 from '@com.amway.commerce/identity-username-config-v1-prod/data.json'; 
import data8 from '@com.amway.commerce/masterdata-country-v1-draft/data.json'; 
import data9 from '@com.amway.commerce/masterdata-country-v1-draft/data_th-th.json'; 
import data10 from '@com.amway.commerce/profile-myaccountaddress-v1-prod/data.json'; 
import data11 from '@com.amway.commerce/profile-myaccountaddress-v1-prod/data-tha.json'; 
import data12 from '@com.amway.commerce/profile-myaccountaddress-v1-prod/data-latam.json'; 
import data13 from '@com.amway.commerce/profile-myaccountprofile-v1-prod/data.json'; 
import data14 from '@com.amway.commerce/profile-myaccountprofile-v1-prod/data-tha.json'; 
import data15 from '@com.amway.commerce/profile-myaccountprofile-v1-prod/data-latam.json'; 
import data16 from '@com.amway.commerce/profile-registration-flow-config-v1-prod/data.json'; 
import data17 from '@com.amway.commerce/profile-registration-flow-config-v1-prod/data-tha.json'; 
import data18 from '@com.amway.commerce/profile-registration-flow-config-v1-prod/data-latam.json'; 
import data19 from '@com.amway.commerce/profile-registrationvalidations-v1-prod/data.json'; 
import data20 from '@com.amway.commerce/profile-registrationvalidations-v1-prod/data-tha.json'; 
import data21 from '@com.amway.commerce/profile-registrationvalidations-v1-prod/data-latam.json'; 
import data22 from '@com.amway.commerce/search-searchconfig-v1-prod/data.json'; 
import data23 from '@com.amway.commerce/search-searchconfig-v1-prod/data-tha.json'; 
import data24 from '@com.amway.commerce/search-searchconfig-v1-prod/data-latam.json'; 
import data25 from '@com.amway.commerce/webshop-configs-v1-prod/data.json'; 
import data26 from '@com.amway.commerce/webshop-configs-v1-prod/data-tha.json'; 
import data27 from '@com.amway.commerce/webshop-configs-v1-prod/data-latam.json'; 
import data28 from '@com.amway.commerce/webshop-currency-v1-prod/data.json'; 
import data29 from '@com.amway.commerce/payment-paymentconfig-v1-prod/data.json';  
  
const masterDataFactory = { 
    '@com.amway.commerce/abomonetization-myshopconfig-v1-prod/data.json': data1,
    '@com.amway.commerce/abomonetization-myshopconfig-v1-prod/data-tha.json': data2,
    '@com.amway.commerce/abomonetization-myshopconfig-v1-prod/data-latam.json': data3,
    '@com.amway.commerce/cart-cartconfig-v1-prod/data.json': data4,
    '@com.amway.commerce/checkout-config-v1-prod/data.json': data5,
    '@com.amway.commerce/identity-identity-config-v1-prod/data.json': data6,
    '@com.amway.commerce/identity-username-config-v1-prod/data.json': data7,
    '@com.amway.commerce/masterdata-country-v1-draft/data.json': data8,
    '@com.amway.commerce/masterdata-country-v1-draft/data_th-th.json': data9,
    '@com.amway.commerce/profile-myaccountaddress-v1-prod/data.json': data10,
    '@com.amway.commerce/profile-myaccountaddress-v1-prod/data-tha.json': data11,
    '@com.amway.commerce/profile-myaccountaddress-v1-prod/data-latam.json': data12,
    '@com.amway.commerce/profile-myaccountprofile-v1-prod/data.json': data13,
    '@com.amway.commerce/profile-myaccountprofile-v1-prod/data-tha.json': data14,
    '@com.amway.commerce/profile-myaccountprofile-v1-prod/data-latam.json': data15,
    '@com.amway.commerce/profile-registration-flow-config-v1-prod/data.json': data16,
    '@com.amway.commerce/profile-registration-flow-config-v1-prod/data-tha.json': data17,
    '@com.amway.commerce/profile-registration-flow-config-v1-prod/data-latam.json': data18,
    '@com.amway.commerce/profile-registrationvalidations-v1-prod/data.json': data19,
    '@com.amway.commerce/profile-registrationvalidations-v1-prod/data-tha.json': data20,
    '@com.amway.commerce/profile-registrationvalidations-v1-prod/data-latam.json': data21,
    '@com.amway.commerce/search-searchconfig-v1-prod/data.json': data22,
    '@com.amway.commerce/search-searchconfig-v1-prod/data-tha.json': data23,
    '@com.amway.commerce/search-searchconfig-v1-prod/data-latam.json': data24,
    '@com.amway.commerce/webshop-configs-v1-prod/data.json': data25,
    '@com.amway.commerce/webshop-configs-v1-prod/data-tha.json': data26,
    '@com.amway.commerce/webshop-configs-v1-prod/data-latam.json': data27,
    '@com.amway.commerce/webshop-currency-v1-prod/data.json': data28,
    '@com.amway.commerce/payment-paymentconfig-v1-prod/data.json': data29
};
  

export default masterDataFactory;